module.exports = __webpack_public_path__ + "d7440a79.png";